<section class="community-eat">
    <div class="container">
        <!-- Header Section -->
        <div class="eat-header">
            <div class="header-content">
                <h1 class="page-title">
                    <i class="fas fa-utensils"></i>
                    What to eat?
                </h1>
                <p class="page-description">
                    Check out JointHawker's recommended cuisines!
                </p>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="isLoading">
            <div class="loading-spinner">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading delicious food...</p>
            </div>
        </div>

        <!-- Food Items Grid -->
        <div class="row" *ngIf="!isLoading && eatList.length > 0">
            <div class="col-lg-4 col-md-6 mb-4" *ngFor="let item of eatList; trackBy: trackById">
                <div class="cmn-swiper-card">
                    <div>
                        <a href="javascript:void(0)" (click)="findShops(item)">
                            <picture>
                                <img [alt]="item.title" class="cmnSwiperCard-image" style="width: 100%; height: auto"
                                    [src]="item.image" (error)="$event.target.src='assets/images/food/pizza.webp'" />
                            </picture>
                        </a>
                    </div>
                    <div class="cmn-swiper-card__body">
                        <h4>
                            <b><a class="" style="color: #000000" href="javascript:void(0)">{{ item.title }}</a></b>
                        </h4>

                        <p>{{ item.description }}</p>
                        <div class="item">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="store" role="img"
                                viewBox="0 0 616 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M602 118.6c33.5 0 60.5-28.3 60.5-63s-27-63-60.5-63S541.5 27.6 541.5 62.5s27 56.1 60.5 56.1zm0-85.9c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2zm-602 0c13.8 0 25 11.7 25 26.2S13.8 84.9 0 84.9s-25-11.7-25-26.2 11.2-26.2 25-26.2zm602 341.4c33.5 0 60.5-28.3 60.5-63s-27-63-60.5-63S541.5 284.7 541.5 319.6s27 56.1 60.5 56.1zm0-85.9c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2zm-602 0c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2zm602 341.4c33.5 0 60.5-28.3 60.5-63s-27-63-60.5-63S541.5 627.8 541.5 662.7s27 56.1 60.5 56.1zm0-85.9c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2zm-602 0c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2zm602 341.4c33.5 0 60.5-28.3 60.5-63s-27-63-60.5-63S541.5 970.9 541.5 1005.8s27 56.1 60.5 56.1zm0-85.9c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2zm-602 0c13.8 0 25 11.7 25 26.2s-11.2 26.2-25 26.2-25-11.7-25-26.2 11.2-26.2 25-26.2z">
                                </path>
                            </svg>
                            <a href="javascript:void(0)">{{ item.shopName }}</a>
                        </div>
                        <div class="item" *ngIf="item.price">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="dollar-sign"
                                role="img" viewBox="0 0 288 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 12.8-29.5 29.2-29.5h66.4c12.4 0 24.1 4.8 32.8 13.5l61.3 61.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L242.4 123.5c-17.4-17.4-41.1-27.5-65.7-27.5H144c-35.3 0-64 28.7-64 64v16c0 35.3 28.7 64 64 64h66.4c12.4 0 24.1 4.8 32.8 13.5l61.3 61.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L242.4 123.5c-17.4-17.4-41.1-27.5-65.7-27.5H144c-35.3 0-64 28.7-64 64v16c0 35.3 28.7 64 64 64z">
                                </path>
                            </svg>
                            <span>{{ item.price }}</span>
                        </div>
                    </div>
                    <div class="text-center mt-4 mb-3">
                        <button class="my-button-3" (click)="findShops(item)">Find shops</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!isLoading && eatList.length === 0">
            <div class="empty-content">
                <i class="fas fa-utensils"></i>
                <h3>No Food Found</h3>
                <p>No food recommendations are available at the moment. Check back later for new content!</p>
            </div>
        </div>

        <!-- Load More Button -->
        <div class="load-more-container" *ngIf="!isLoading && hasMoreItems && eatList.length > 0">
            <button class="load-more-btn" (click)="loadMore()" [disabled]="isLoadingMore"
                [class.loading]="isLoadingMore">
                <span *ngIf="!isLoadingMore">
                    <i class="fas fa-plus"></i>
                    Load More Food
                </span>
                <span *ngIf="isLoadingMore">
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                </span>
            </button>
        </div>

        <!-- Loading More Items -->
        <div class="loading-more" *ngIf="isLoadingMore">
            <div class="loading-more-content">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading more delicious food...</p>
            </div>
        </div>
    </div>
</section>

